var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('performance-review-report',{attrs:{"performance-review":_vm.performanceReview}})}
var staticRenderFns = []

export { render, staticRenderFns }